import { makeStyles } from '@material-ui/core';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HouseDetailIcon, UserIcon } from 'components/Icons/Menu';
import { AppContext } from 'context';
import { EtemMenuItem } from '.';
import Menu from './Menu';
import { STATE_MENU_STYLES } from './Menu.style';
import { Routes } from '../../routes';

const useStyles = makeStyles({
  ...STATE_MENU_STYLES,
});

const MenuList = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const context = useContext(AppContext);

  const menuItems = useMemo<Array<Array<EtemMenuItem>>>(() => {
    const shouldBeAdmin = context.hasLeastOneAdminRole();
    return [
      [
        {
          text: t('menuItem.administration.home'),
          to: Routes.AdministrationHomepage,
          urlMatch: [Routes.AdministrationHomepage],
          icon: <HouseDetailIcon className={classes.icon} />,
          exact: true,
          canAccess: shouldBeAdmin,
        },
        {
          text: t('menuItem.administration.users'),
          to: Routes.AdministrationUsers,
          icon: <UserIcon className={classes.icon} />,
          exact: true,
          urlMatch: [
            Routes.AdministrationUsers,
            Routes.AdministrationUserCreate,
            Routes.AdministrationUserShow,
            Routes.AdministrationUserSortingCenterUserRole,
          ],
          canAccess: shouldBeAdmin,
        },
      ],
    ];
  }, [classes.icon, t, context]);

  return <Menu menuItems={menuItems} />;
};

export default MenuList;
